import { render, staticRenderFns } from "./TwoFactorAuth.vue?vue&type=template&id=3cc1345e&scoped=true&"
import script from "./TwoFactorAuth.vue?vue&type=script&lang=js&"
export * from "./TwoFactorAuth.vue?vue&type=script&lang=js&"
import style0 from "./TwoFactorAuth.vue?vue&type=style&index=0&id=3cc1345e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc1345e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cc1345e')) {
      api.createRecord('3cc1345e', component.options)
    } else {
      api.reload('3cc1345e', component.options)
    }
    module.hot.accept("./TwoFactorAuth.vue?vue&type=template&id=3cc1345e&scoped=true&", function () {
      api.rerender('3cc1345e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Profile/Security/TwoFactorAuth/TwoFactorAuth.vue"
export default component.exports